import { toYMD } from "./scheduleUtils";

export function buildScheduleCounts(rows) {
  const list = rows || [];

  return {
    pending: list.filter((r) => r.status === "pending").length,
    scheduled: list.filter((r) => r.status === "scheduled").length,
    delivered: list.filter((r) => r.status === "delivered").length,
    late: list.filter((r) => r.status === "late").length,
  };
}

export function buildCalendarEvents(rows) {
  return (rows || [])
    .map((row) => {
      const ymd = toYMD(row.scheduledDate);
      if (!ymd) return null;
      return {
        id: row.id,
        requestId: row.requestId || null,
        date: ymd,
        title: `${row.material} – ${row.donor}`,
        material: row.material || "—",
        donor: row.donor || "—",
        timeWindow: row.timeWindow || "—",
        timeStart: row.timeStart || null,
        timeEnd: row.timeEnd || null,
        requestedQty: row.requestedQty,
        allocatedQty: row.allocatedQty,
        status: row.status,
      };
    })
    .filter(Boolean);
}
